import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import PreviousMarksEntry from '../views/create-exams/previous-marks-entry';
import PreviousExamSetup from '../views/create-exams/previous-exam-setup';
// import ExamFeeMapping from '../views/application/exam_fee_setup/fee-setup-new/fee-mapping';
// import ExamFeeCode from 'views/application/exam_fee_setup/fee-setup-new/fee-code';

const ExamSetup = Loadable(lazy(() => import('views/create-exams/exam-setup/ExamSetUp')));
const ExamTimeSetup = Loadable(lazy(() => import('views/create-exams/exam-setup/ExamTimeSetup')));
const ExamTimeSetupList = Loadable(lazy(() => import('views/create-exams/exam-setup/ExamTimeSetupList')));

const ExamAttendanceSetup = Loadable(lazy(() => import('views/create-exams/Attendance/index')));
const InternalAssessmentMarksSetup = Loadable(lazy(() => import('views/create-exams/Internal-Assessment/index')));
const ExamTimeSetupEdit = Loadable(lazy(() => import('views/create-exams/exam-setup/EditExamTimeSetup')));
const ExamInternalMarksEntry = Loadable(lazy(() => import('views/create-exams/exam_marks_entry/index')));
const ViewApprovedMarks = Loadable(lazy(() => import('views/create-exams/exam_marks_entry/ViewApprovedMarks')));
const MarksEntrySetup = Loadable(lazy(() => import('views/create-exams/Marks-Entry/index')));
const ExamTimeTable = Loadable(lazy(() => import('views/create-exams/examTimeTable/index')));
const MarksApproval = Loadable(lazy(() => import('views/create-exams/Marks-Approval/index')));
const MarkSheet = Loadable(lazy(() => import('views/markSheet/TabsComponent')));
const SemesterGradeSheet = Loadable(lazy(() => import('views/markSheet/semestergrade/index')));
const ExamtimeTableMangements = Loadable(lazy(() => import('views/examtimeTableSetup/index')));
const ExamtimeTableMangementsAdd = Loadable(lazy(() => import('views/examtimeTableSetup/ExamTimeSetup')));
const ExamtimeTableMangementsEdit = Loadable(lazy(() => import('views/examtimeTableSetup/EditExamTimeTable')));
const BacklogPaperEntry = Loadable(lazy(() => import('views/create-exams/backlogentry/AdminSideBacklogEntry')));
const BacklogStudents = Loadable(lazy(() => import('views/create-exams/backlogentry/BacklogStudents')));
const GenerateHallTicket = Loadable(lazy(() => import('views/generate_hallticket/GenerateHallTicket')));
const OverAllAcedemicReort = Loadable(lazy(() => import('views/create-exams/over_all_academic_report/AcademicReport')));
const AcademicStates = Loadable(lazy(() => import('views/academicStates/index')));
const DepartmentAcademicStates = Loadable(lazy(() => import('views/academicStates/DepartmentAcademicStates')));
const CourseAcademicStates = Loadable(lazy(() => import('views/academicStates/CourseAcademicStates')));
const SessionalMarksEntry = Loadable(lazy(() => import('views/create-exams/SessionalMarksEntry/SessionalMarksEntry')));
const MrksApprovalList = Loadable(lazy(() => import('views/create-exams/SessionalMarksEntry/sessionalmarksapprovals')));
const ExamFeeCode = Loadable(lazy(() => import('views/application/exam_fee_setup/fee-setup-new/fee-code')));
const ExamFeeMapping = Loadable(lazy(() => import('../views/application/exam_fee_setup/fee-setup-new/fee-mapping')));
const BAMSGradeSheetPdf = Loadable(lazy(() => import('views/gradeSheet/index')));
const MBBSGradeSheetPdf = Loadable(lazy(() => import('views/gradeSheet/MBBSExamGradeSheet')));
const NewBAMSGradeShhetPdf = Loadable(lazy(() => import('views/gradeSheet/NewBAMSGradeSheet')));
const ExamReEvaluationReport = Loadable(lazy(() => import('views/examReEvaluationReport/index')));
const StudentReEvaluationReport = Loadable(lazy(() => import('views/examReEvaluationReport/StudentReEvaluationReport')));
const ExamReEvaluationStudentReport = Loadable(lazy(() => import('views/examReEvaluationReport/PaperStudentList')));
const ExamReEvaluationEntry = Loadable(lazy(() => import('views/examReEvaluationReport/ReMarksEntry')));
const BulkBAMSGradeSheetPdf = Loadable(lazy(() => import('views/gradeSheet/BulkGradeSheetFilters')));
const BulkMBBSGradeSheetPdf = Loadable(lazy(() => import('views/gradeSheet/BulkMbbsGradeSheet')));
const TransScriptPdf = Loadable(lazy(() => import('views/transript/Transript')));
const EMBBSGradeSheet = Loadable(lazy(() => import('views/student/WebView/eGradeSheet/MBBSEGradeSheet')));
const ElectiveSubjectSelection = Loadable(lazy(() => import('views/elective-subject-selection')));
const AllowedStudentListAccountHead = Loadable(lazy(() => import('views/create-exams/exam-setup/ExamStudentListforAccountHead')));

const AllowStudentGradeSheet = Loadable(lazy(() => import('views/create-exams/exam-setup/allowed-student/AllowGradeSheetStudent')));
const ExamAttendanceReport = Loadable(lazy(() => import('views/create-exams/examreports/ExamAttendanceReport')));

const OfflineReEvaluation = Loadable(lazy(() => import('views/create-exams/exam-setup/OfflineApplyReEvaluation')));

const ExamFoilReport = Loadable(lazy(() => import('views/create-exams/examreports/ExamFoilReport')));
const ExamSetupReport = Loadable(lazy(() => import('views/create-exams/examsetupReport/index')));
const NewBAMSGradeSheet = Loadable(lazy(() => import('views/gradeSheet/NewBAMSGradeSheet')));

// C:\Users\Chethana Kumar\Desktop\ustm_New\entrarv3Frontend\src\views\create-exams\examreports\ExamAttendanceReport.js

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const ExamRoutes = {
    path: '/',
    element: (
        <AuthGuard roles={roles}>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/exam/setup',
            element: <ExamSetup />
        },
        {
            path: '/exam/time/setup/:id/:examType',
            element: <ExamTimeSetup />
        },
        {
            path: '/exam/time/setup/list/:id/:type',
            element: <ExamTimeSetupList />
        },
        {
            path: '/exam/attendence',
            element: <ExamAttendanceSetup />
        },
        {
            path: '/exam/time/setup/edit/:id',
            element: <ExamTimeSetupEdit />
        },
        {
            path: '/exam/marks/internal-assessment',
            element: <InternalAssessmentMarksSetup />
        },
        {
            path: '/exam/internal/marks/entry',
            element: <ExamInternalMarksEntry />
        },
        {
            path: '/view/approved/internal/marks/entry',
            element: <ViewApprovedMarks />
        },
        {
            path: '/exam/marks/add',
            element: <MarksEntrySetup />
        },
        {
            path: '/exam/timetable',
            element: <ExamTimeTable />
        },
        {
            path: '/exam/marks/approval',
            element: <MarksApproval />
        },
        {
            path: '/exam/marksheet',
            element: <MarkSheet />
        },
        {
            path: '/exam/semestergradesheets',
            element: <SemesterGradeSheet />
        },
        {
            path: '/exam/timetable/setup/:examGroupId',
            element: <ExamtimeTableMangements />
        },
        {
            path: '/exam/timetable/setup/Add/:examGroupId',
            element: <ExamtimeTableMangementsAdd />
        },
        {
            path: '/exam/timetable/setup/edit/:examTimeTableId/:examId',
            element: <ExamtimeTableMangementsEdit />
        },
        {
            path: '/backlog/students',
            element: <BacklogStudents />
        },
        {
            path: '/backlog/paper',
            element: <BacklogPaperEntry />
        },
        {
            path: '/generate/hallticket',
            element: <GenerateHallTicket />
        },
        {
            path: '/overall/academic/report',
            element: <OverAllAcedemicReort />
        },
        {
            path: '/exam/performance',
            element: <AcademicStates />
        },
        {
            path: '/exam/department/academicstates/:schoolId/:sessionId?',
            element: <DepartmentAcademicStates />
        },
        {
            path: '/exam/course/academicstates/:departmentId/:sessionId?',
            element: <CourseAcademicStates />
        },
        {
            path: '/sessional/marks/entry',
            element: <SessionalMarksEntry />
        },
        {
            path: '/sessional/marks/approval',
            element: <MrksApprovalList />
        },
        {
            path: '/exam/fee-code',
            element: <ExamFeeCode />
        },
        {
            path: '/exam/fee-mapping',
            element: <ExamFeeMapping />
        },
        {
            path: '/exam/gradesheet',
            element: <BAMSGradeSheetPdf />
        },
        {
            path: '/mbbs/exam/gradesheet',
            element: <MBBSGradeSheetPdf />
        },
        {
            path: '/new/exam/gradesheet',
            element: <NewBAMSGradeShhetPdf />
        },
        {
            path: '/exam/gradesheet/bulk',
            element: <BulkBAMSGradeSheetPdf />
        },
        {
            path: '/bulk/mbbs/gradesheet/bulk',
            element: <BulkMBBSGradeSheetPdf />
        },
        {
            path: '/re/evaluation/report',
            element: <ExamReEvaluationReport />
        },
        {
            path: '/update/marks/:examgroupId/:subjectDetailId/:courseDetailId/:studentId',
            element: <ExamReEvaluationEntry />
        },
        {
            path: '/re/evaluation/studentlist/:examgroupId/:subjectDetailId/:courseDetailId',
            element: <ExamReEvaluationStudentReport />
        },
        {
            path: '/student/re/evaluation/report',
            element: <StudentReEvaluationReport />
        },
        {
            path: '/exam/previous-exam-setup',
            element: <PreviousExamSetup />
        },
        {
            path: '/exam/previous-marks-entry',
            element: <PreviousMarksEntry />
        },
        {
            path: '/transcript',
            element: <TransScriptPdf />
        },
        {
            path: '/webview/egradesheet/mbbs',
            element: <EMBBSGradeSheet />
        },
        {
            path: '/webview/egradesheet/bms',
            element: <NewBAMSGradeSheet />
        },
        {
            path: '/elective-subject-selection/by-admin',
            element: <ElectiveSubjectSelection />
        },
        {
            path: '/allowed/studentlist',
            element: <AllowedStudentListAccountHead />
        },
        {
            path: '/exam/attendance/report',
            element: <ExamAttendanceReport />
        },
        {
            path: '/exam/foil/report',
            element: <ExamFoilReport />
        },
        {
            path: '/exam/setup/report',
            element: <ExamSetupReport />
        },
        {
            path: '/allow/student/gradesheet',
            element: <AllowStudentGradeSheet />
        },
        {
            path: '/offline/re/evalution',
            element: <OfflineReEvaluation />
        }
    ]
};
export default ExamRoutes;
